export default __webpack_public_path__ + "static/media/toolbar-attachment.9070f962.svg";